export default __webpack_public_path__ + "static/media/more-digital-library.670256d5.svg";